/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import SidePanelContainer from '../controls/SidePanelContainer';

type Props = {
  handleClose: () => void;
};

/**
 * Modal - AddDeviceModal.
 * @param props - Properties of AddDeviceModal.
 * @returns ReactElement.
 */
export default function GuideSerialNumberModal(props: Props): ReactElement {
  const { handleClose } = props;

  return (
    <SidePanelContainer closeModal={() => handleClose()}>
      <img src="/assets/serial_number.webp" alt="serial-number" />
    </SidePanelContainer>
  );
}
